import React from "react";

import MuiBox from "@mui/material/Box";


export const Box = ({ sx, children, ...props }: any) => {
    let height = props?.height ?? '1.5px';
  return (
    <MuiBox
      component={'hr'}
      sx={{
        '&':{
          position: 'relative',
          outline: 0,
          border: 0,
          color: '#000',
          textAlign: 'center',
          opacity: '.5',
        },
        '&:before': {
          content: '""',
          background: "linear-gradient(90deg, transparent, #818078, transparent)",
          position: "absolute",
          left: 0,
          top: "50%",
          width: "100%",
          height: "1px"
        },
        '&:after':{
          content: "attr(data-content)",
          position: "relative",
          display: "inline-block",
          padding: "0 .5em",
          color: "#818078",
          backgroundColor: "#fcfcfa"
        },
        height,
        ...sx
      }}
      
      {...props}
    />
  );
};

export default Box;